import { useCallback, useState } from 'react';

export function useModalExt() {
  const [open, setOpen] = useState(false);

  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    modalProps: { open, destroyOnClose: true },
    onOpen,
    onClose,
  };
}
